<template>
<div class="chapter">
<div class="inner_page">
<p class="sp"> </p>
<p class="FMEP"><span class="ePub-I">The clock did not create an interest in time measurement; the interest in time measurement led to the invention of the clock.</span></p>
<p class="FMEPC">—David Landes, <span class="ePub-I">Revolution in Time</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?61571c80